var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.698043.589564c.08744308-.058816.16551726-.13637.26493172-.176448.5808719-.240989 1.24137946-.262849 1.856604-.406506.78750823-.181652 2.31880315 3.438387 1.33975293 3.752766-.36382568.113988-1.51151612.286272-1.81444394.514769-.27013667.203513-.14157452.702667.12491869 1.016526.70266762.826024 1.73428778 1.746259 2.55094371 2.553025l.00104098-.00052c.02081979.02134.04476253.045803.0671438.068185.02238126.022381.04632401.045283.06870528.067143h-.00104099c.80624603.816136 1.72595987 1.849317 2.55250519 2.551465.3143787.267013.81301246.394534 1.01652583.124398.2279766-.302408.4007808-1.450618.5142486-1.814444.3143787-.97905 3.9354592.552765 3.7532861 1.340794-.144177.614704-.1660378 1.27417-.4065063 1.856083-.041119.098374-.1191932.176448-.1769681.265973-1.3116462 2.066884-4.49134732 2.332856-6.86011795.316461-.9046195-.769812-1.78373477-1.571373-2.63838679-2.396357l-.00468445.004164c-.02238127-.022902-.04268055-.046845-.06610281-.069226-.02134027-.022381-.04580352-.043722-.06922577-.066103l.00416396-.004684c-.82550433-.855173-1.62550443-1.732727-2.39635684-2.638387C-.63585449 5.080911-.36884079 1.90069 1.698043.589564z",
    fill: "#C1CEDE",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandset);
export default __webpack_public_path__ + "static/media/handset.7390d22d0d14a41c21881baa2ca7850b.svg";
export { ForwardRef as ReactComponent };